// extracted by mini-css-extract-plugin
export default {"tab":"tabs_tab__Lqw1+","tabs":"tabs_tabs__TZzTa"};